module.exports = __webpack_public_path__ + "img/01.c12fc39c.jpg";